module.exports = __webpack_public_path__ + "img/user.9fbae09f.svg";